import React from 'react';

import utils from './MoleculeCardUtils';


export default class MoleculeCardTitle extends React.Component {

  render() {
    const { molecule, onAction } = this.props;
    const title = utils.parseMoleculeFirst(
      molecule || {}, 'txt', 'title', 'render'
    );
    return (
      <div
        style={{padding: '1px 3px', marginTop: 5}}
        onTouchTap={e => {
          if (onAction) {
            onAction({
              name: 'click',
              molecule: molecule,
              target: 'molecule-card-title',
            });
          }
        }}
      >
        <h3 style={{
          color: '#333',
          fontSize: '13px',
          lineHeight: '1.3em',
          margin: '0 0 1px 0',
        }}>{title}</h3>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/MoleculeCard/MoleculeCardTitle.jsx